import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';

export const ACCOUNT_KEY = ['account'];
const FIFTEEN_MINUTES = 15 * 60 * 1000;

const useAccountData = (options = {}) => useQuery(
    ACCOUNT_KEY,
    () => apiClient.get('/Account/').then(r => r.data),
    { staleTime: FIFTEEN_MINUTES, ...options }
);

export default useAccountData;
